
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontaktni-formular",
      function () {
        return require("private-next-pages/kontaktni-formular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kontaktni-formular"])
      });
    }
  